/**
 * Get affiliate referral code from various sources (for display/UI)
 */
export function getAffiliateRef(): string | undefined {
  // 1) Get from URL ?via=... (Rewardful standard) or ?ref=... (legacy)
  const params = new URLSearchParams(window.location.search);
  const urlRef = params.get('via') ?? params.get('ref') ?? undefined;

  // 2) Get from Rewardful cookie if exists
  const rewardfulCookie = document.cookie
    .split('; ')
    .find(r => r.startsWith('Rewardful.referral='))
    ?.split('=')[1];

  // 3) Get from localStorage (cached from previous visits)
  const savedRef = localStorage.getItem('affiliateRef') || undefined;

  // Priority: URL -> Rewardful cookie -> saved
  const ref = urlRef || rewardfulCookie || savedRef || undefined;

  // Save to localStorage for future visits
  if (ref) {
    localStorage.setItem('affiliateRef', ref);
  }

  return ref;
}

/**
 * Get Rewardful referral token from their JS API
 * This is what Rewardful uses for attribution in Stripe
 */
export function getRewardfulReferralToken(): string | undefined {
  try {
    // Get token from Rewardful JS API
    const rewardfulToken = (window as any)?.Rewardful?.referral;
    
    // Check cookie backup (using existing logic in getAffiliateRef)
    // Check if script is loaded (for debugging purposes)
    
    // FALLBACK: If Rewardful token is empty/undefined, use affiliate ref
    const affiliateRef = getAffiliateRef();
    const finalToken = rewardfulToken && rewardfulToken.trim() !== ''
      ? rewardfulToken
      : affiliateRef;
    
    return finalToken || undefined;
  } catch (error) {
    console.warn('Failed to get Rewardful token:', error);
    return undefined;
  }
}

/**
 * Get promo code from URL parameters
 */
export function getPromoCodeFromUrl(): string | undefined {
  const params = new URLSearchParams(window.location.search);
  return params.get('promo') || 
         params.get('promocode') || 
         params.get('code') || 
         undefined;
}

/**
 * Clear saved referral (for testing)
 */
export function clearSavedReferral(): void {
  localStorage.removeItem('affiliateRef');
}